import { CustomAttributeFieldConfig } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import { getKindLikeValueSafely } from 'src/graphql/entities/custom-attributes/field-view-registry/utils';
import { LookupView } from './lookup-view';
import { decodeLookup } from './utils';

export const LOOKUP_FIELD_CONFIG: CustomAttributeFieldConfig = {
  type: 'lookup_relational',
  editable: false,
  View: LookupView,
  decode: (raw) => ({ kind: 'lookup_relational', value: decodeLookup(raw) }),
  encode: (value) => getKindLikeValueSafely(value, 'lookup_relational'),
  isEmpty: (value) => !getKindLikeValueSafely(value, 'lookup_relational'),
};
